<div #refModalTrigger><ng-content select="[trigger]"></ng-content></div>
@if ((refModalTrigger.children.length == 0)) {
  <div>
    <button nz-button nzType="primary" (click)="showModal(null)">
      <i nz-icon nzType="plus-circle" nzTheme="outline"></i><span>{{triggerTitle}}</span>
    </button>
  </div>
}
<nz-modal
  [nzMaskClosable]="false"
  [nzNoAnimation]="true"
  [nzVisible]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  [nzWidth]="isNew ? 560 : 1000"
  >
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <app-add-edit-form #form [editObject]="object" (formFinished)="onFormFinished($event)"></app-add-edit-form>
  </ng-template>

  <ng-template #modalFooter>
    @if (!isNew) {
      <button nz-button nzType="default" (click)="handleResetPass()" class="left-space">Passwort zurücksetzen</button>
    }
    @if (!isNew) {
      <button nz-button nzType="default" (click)="regenerateBatch()" class="left-space">Batch neu generieren</button>
    }
    <button nz-button class="left-space" nzType="default" (click)="handleCancel()">Abbrechen</button>
    <button nz-button class="left-space" nzType="primary" (click)="handleOk()" [nzLoading]="isConfirmLoading">Speichern</button>
  </ng-template>
</nz-modal>
